// extracted by mini-css-extract-plugin
export default {"title":"Aaa-z","warning":"Baa-z","sizeOptionsLegendText":"Caa-z"};